import styled from 'styled-components';
import getContrastFontColor from '@utils/getContrastFontColor';
import { media } from 'styled-bootstrap-grid';

export const LandingPageCategoryPicker = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  min-width: 280px;
  padding: 8px;
  border-radius: 6px;
  background-color: #ffffff;

  ${media.sm`
    min-width: 400px;
  `}
`;

export const SearchButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 58px;
  height: 58px;
  border-radius: 6px;
  border: 0;
  color: ${({ theme }) =>
    getContrastFontColor(
      theme.customColors.primary,
      theme.defaultColors.fontPrimary,
      theme.defaultColors.lighterGrey
    )};
  background-color: ${({ theme }) => theme.customColors.primary};
  cursor: pointer;
  filter: brightness(1);
  transition: filter 0.2s ease-in-out;

  &:hover {
    filter: brightness(1.2);
    transition: filter 0.1s ease-in-out;
  }

  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;

    &:hover {
      filter: brightness(1);
    }
  }
`;

export const CategoryPickerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;

  select {
    min-height: 56px;
    padding-left: 10px;
    display: flex;
    align-items: center;
  }

  label {
    position: absolute;
    top: 0;
    left: 10px;
    margin-bottom: 4px;
    font-size: 12px;
    color: gray;
    z-index: 10;
  }

  & .categoryPickerField,
  & .categoryPickerField > div,
  & .landingPageFieldContainer,
  & .landingPageFieldContainer > div {
    height: 100%;
  }

  & .categoryPickerField select {
    position: relative;
    top: 8px;
    border-width: 0;
    outline: none;
  }

  & .landingPageFieldContainer > div {
    border-radius: 6px;
    border-width: 0;
  }

  & .landingPageFieldContainer > div > div:first-of-type {
    position: relative;
    top: 8px;
  }
`;
